import React from 'react';
import {useSelector} from 'react-redux'
import { Link } from 'react-router-dom';
const WelcomePage = () => {

  const cardData = useSelector(state => state.cardGrid)

    return (
<div className="ui two column grid ">
        <div className="column">
          <p></p>
          <div className="card">
            
                <div className="content">
                  <div className="header">Browse the Gallery</div>
                  <div className="description">
                    Browse the Gallery to see what cards are available and to check card price history data
                  </div>
                  <div className="ui large image">
                    <img alt="gallery" src="./img/cards.jpg"/>
                  </div>
                </div>
                <div className="ui bottom attached button">
                  <i className="add icon"></i>
                  <Link to="/gallery">View the Gallery</Link>
                </div>
              </div>
        </div>
        <div className="column">
          <p></p>
          <div className="card">
          
                <div className="content">
                  <div className="header">Manage your Collection</div>
                  <div className="description">
                    Log in to manage your collection, check valuation, and add inventory
                  </div>
                  <div className="ui large  image">
                    <img alt="grid" src="./img/grid.png"/>
                  </div>
                </div>
                <div className="ui bottom attached button">
                  <i className="add icon"></i>
                  <Link to="/mygrid">{cardData && cardData.isUserLoggedIn ? 'View Your Collection' : 'Log In'}</Link>
                  
                </div>
              </div>
        </div>
      </div>
    )}
    export default WelcomePage